import { useTranslation } from "react-i18next"

import { AlertTriangle } from "@/components/icons"
import { cn } from "@/lib/utils"

interface TenderAiDisclaimerProps {
  className?: string
}

export function TenderAiDisclaimer({ className }: TenderAiDisclaimerProps) {
  const { t } = useTranslation()
  return (
    <p className={cn("text-muted-foreground flex items-center gap-1.5 text-xs", className)}>
      <AlertTriangle className="size-3 shrink-0" />
      {t("questioninput.ai_generated_content_warning")}
    </p>
  )
}
